import {mixins} from "../app/mixin";

mixins.push({
    el: '.opportunitiesStepper',
    data() {
        return {
            activeStep: 1,
        }
    },
    methods: {
        setActiveStep(step) {
            if (step !== this.activeStep) {
                this.activeStep = step
            }
        },
    },
});